import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';

export function isIntegrationUserFeatureEnabled(): boolean {
  return FeatureFlags.uiamIntegrationUserLicenseEnabled && getSessionManagementServiceInstance().isOnlineEnvironment();
}
